import { message } from 'antd';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const resetDocumentDefaultFilter = async (id) => {
  try {
    const data = { id, value: false };
    await client.put('/Filter/default', data, {
      headers: authHeader(),
      params: { type: 'DOCS' },
    });
  } catch (err) {
    message.error('Произошла ошибка при сбросе фильтра');
    console.error(err);
    return;
  }
};

export default resetDocumentDefaultFilter;
